var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container__tags"},[_vm._l((_vm.tags),function(tag){return [(_setup.getRoutePath(tag.page))?_c(_setup.NuxtLinkCustom,{key:tag.sys.id,staticClass:"container__tag",attrs:{"to":_setup.getRoutePath(tag.page)}},[_vm._v("\n      "+_vm._s(tag.label)+"\n    ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }